import React, {useEffect, useLayoutEffect, useRef, useState} from "react";
import {Button, Card, Col, Modal, Popover, Row, Tooltip} from "antd";
import {CloseOutlined, DownloadOutlined} from "@ant-design/icons";
import { TransformWrapper, TransformComponent,KeepScale } from "react-zoom-pan-pinch";
import './App.css';
import * as htmlToImage from "html-to-image";
const defaults = {
    chartLength: 800,
    bulletSize: 8,
    min: -180,
    max: 180,
    stepSize: 30,
    borderColor: 'grey',
    xAxis:'X Axis',
    yAxis:'Y Axis',
    scatterData:[],
    fileName:'phisical-checkup_contour_analysis',
    onCanvasLoaded:()=>{},
    deselectEntry:()=>{},
    popupContentRender: ()=><div><p>Content</p></div>
}

export default function Chart({chartProps}) {
    const {
        borderColor,
        chartLength,
        bulletSize,
        scatterData,
        heading,
        subHeading,
        min,
        max,
        stepSize,
        xAxis,
        yAxis,
        backgroundImageUrl,
        fileName,
        popupContentRender,
        onCanvasLoaded,
        deselectEntry
    } = {...defaults,...chartProps }

    const [isGrabbing, setIsGrabbing] = useState(false);
    const [existingScatter, setExistingScatter] = useState({});
    const [isLoaded,setLoaded] = useState(false);
    const [isCanvasLoaded, setIsCanvasLoaded] = useState(false);
    const [bulletContent, setBulletContent] = useState(null);
    const [clickedBullet, setClickedBullet] = useState(null)
    const [scale,setScale] = useState(1);
    const [internalChartLength, setInternalChartLength] = useState(chartLength)
    const backgroundRef = useRef(null);
    const chunks = Math.floor((max - min) / stepSize)
    const elementSize= Math.floor(internalChartLength / chunks)

    const ChartCol = ({colIndex,rowIndex, props}) => <Col {...props} style={{
        borderLeft: `${colIndex === 0 ? 1 : 0}px solid ${borderColor}`,
        borderRight: `1px solid ${borderColor}`,
        borderTop: `${rowIndex === 0 ? 1 : 0}px solid ${borderColor}`,
        borderBottom: `1px solid ${borderColor}`,
        height: elementSize,
        width: elementSize,
        backgroundColor: 'rgba(0, 0, 0, 0)'
    }}/>

    const RowBoundaryCol = (props) => <Col {...props} style={{
        display:"flex",
        alignItems:"flex-start",
        paddingTop:internalChartLength*0.01,
        justifyContent:"center",
        height: elementSize,
        width:elementSize,
        backgroundColor: 'rgba(0, 0, 0, 0)'
    }}/>

    const ColumnBoundaryCol = (props) => <Col {...props} style={{
        display:"flex",
        alignItems: 'center',
        justifyContent:"flex-end",
        paddingRight:internalChartLength*0.02,
        height:elementSize,
        width: elementSize,
        backgroundColor: 'rgba(0, 0, 0, 0)'
    }}/>

    const CornerCell = (props) => <Col {...props} style={{
        display:"flex",
        alignItems:"center",
        paddingRight:internalChartLength*0.02,
        justifyContent:"flex-end",
        height:elementSize,
        width: elementSize,
        backgroundColor: 'rgba(0, 0, 0, 0)'
    }}/>

    const checkBackgroundImageLoaded = () => {
        const element = backgroundRef.current;
        if (!element) return;

        setIsCanvasLoaded(false);

        const bgImage = new Image();
        const backgroundStyle = window.getComputedStyle(element).backgroundImage;
        const imageUrl = backgroundStyle.slice(5, -2);

        bgImage.onload = () => {
            setIsCanvasLoaded(true);
        };

        bgImage.onerror = () => {
            setIsCanvasLoaded(false);
        };

        bgImage.src = imageUrl;
    };
    useEffect(() => {
        if(isCanvasLoaded && typeof onCanvasLoaded === 'function'){
            onCanvasLoaded()
        }
    }, [isCanvasLoaded,onCanvasLoaded]);

    useLayoutEffect(()=>{
        if(JSON.stringify(scatterData) !== JSON.stringify(existingScatter)){
            setClickedBullet(null)
            setBulletContent(null)
            setLoaded(false)
            setTimeout(()=>setLoaded(true),0)
            if (scatterData.length === 1) {
                setBulletContent(scatterData[0].popupContent)
            }
            setExistingScatter(scatterData)
        }
        },
        [existingScatter,scatterData])

    useEffect(() => {
        if (backgroundImageUrl)  {
            checkBackgroundImageLoaded()
        } else {
            setIsCanvasLoaded(true)
        }
    }, [backgroundImageUrl]);
    useEffect(() => {
        setInternalChartLength(chartLength)
    }, [chartLength]);

    const chartRef = useRef(null)

    return (

        <div style={{width:'fit-content', display:"flex",flexDirection:"column",justifyContent:"flex-end",alignItems:'center'}} >
            <div style={{display: "flex", flexDirection: "column", alignItems: "center", width:"85%"}}>
                <p style={{fontSize:20,fontWeight:"bold", marginBottom:0, paddingBottom:0}}>{heading}</p>

                <div style={{display: "flex", flexDirection: "row", justifyContent: "center", width: "100%"}}><div/>
                    <div style={{display: "flex", flexDirection: "column", gap:20, paddingBottom:'2vh'}}>
                        <p style={{fontSize: 16}}>{subHeading}</p>
                        {bulletContent && (
                            <Card>
                                {scatterData.length > 1 && <Button
                                    onClick={()=>{
                                        setClickedBullet(null);
                                        setBulletContent(null)
                                        if (typeof deselectEntry === 'function') {deselectEntry()}
                                    }}
                                    size={'small'}
                                    type="text"
                                    icon={<CloseOutlined style={{fontSize:8}} />}
                                    style={{ margin:0, position: "absolute", top: 0, right: 0 }}/>}
                                {popupContentRender(bulletContent)}
                            </Card>
                        )}
                    </div>
                </div>
            </div>

            <TransformWrapper onTransformed={(e) => setScale(e.state.scale)} wheel={{activationKeys: ["Alt","Meta"]}}>
                <TransformComponent>
                    <div ref={chartRef}>
                    <div style={{display: "flex", paddingTop:10, ...(isGrabbing ? {cursor:'grabbing'}:{})}}  onMouseDown={() => {setIsGrabbing(true);}}
                         onMouseUp={() => {setIsGrabbing(false)}} >
                        <div style={{
                            justifyContent: 'center',
                            height: internalChartLength,
                            display: "flex",
                            alignItems: "center",
                            transform: "rotate(-90deg)",
                        }}>
                            <div style={{position: 'relative', top: elementSize / 2.5, fontSize: "small"}}>
                                {yAxis}
                            </div>
                        </div>
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            width: 'fit-content'
                        }} >
                            {scatterData.map((scatterPoint, index, array) => (

                                <KeepScale key={`${index}_bullet`}  style={{zIndex: 10}}>
                                    <Tooltip key={`${index}_bullet_wrap`} title={scatterPoint.popupTitle} overlayInnerStyle={{ color: 'black', backgroundColor: 'white' }} overlayStyle={{boxShadow:'0 3px 10px rgb(0 0 0 / 0.2)'}}>
                                    <div key={`${index}_bullet`}  style={{
                                        display: "flex",
                                        position: 'relative',
                                        justifyContent: "center",
                                        top: Math.floor(internalChartLength * scale / 2) - Math.floor(bulletSize / 6),
                                        ...(isLoaded ? {
                                            transform: `translate(${(scatterPoint.x / (max - min)) * internalChartLength * scale}px,${-1 * (scatterPoint.y / (max - min)) * internalChartLength * scale}px)`,
                                            transition: 'transform 2s ease'
                                        } : {
                                            opacity: 0
                                        }),
                                        width: 0,
                                        height: 0,
                                        lineHeight: 0,
                                        margin: 0,
                                        padding: 0,
                                        textAlign: 'center',
                                        fontSize: bulletSize * (1 + (scale - 1) / 8),
                                        color: scatterPoint.color,

                                    }}>
                                        <p className="bullet" style={{cursor: 'pointer'}}
                                           onClick={() =>{
                                               if (scatterData.length > 1) {
                                                   setBulletContent(scatterPoint.popupContent)
                                                   setClickedBullet(index)}
                                               }}
                                        >
                                            ● {clickedBullet === index && (<b style={{fontSize: bulletSize * (1 + (scale - 1) / 8)*1.5 }}>&#8858; </b>)}
                                        </p>
                                    </div>
                                    </Tooltip>
                                </KeepScale>

                            ))}
                            <div style={{
                                display: "flex", justifyContent: "center",
                                alignItems: "flex-start"
                            }}>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: 'column'
                                    }}>{[...Array(chunks)].map((_, columnIndex) => (
                                    <ColumnBoundaryCol key={`${columnIndex}_border_h`}>
                                        <div style={{
                                            position: 'relative',
                                            bottom: "50%",
                                            fontSize: "smaller"
                                        }}>{min + stepSize * (chunks - columnIndex)}</div>
                                    </ColumnBoundaryCol>))}</div>
                                <div
                                    ref={backgroundRef}
                                    style={(backgroundImageUrl) ? {
                                        backgroundSize: "cover",
                                        backgroundPosition: 'center',
                                        backgroundImage: `url(${backgroundImageUrl}`,
                                    } : {
                                        backgroundColor: '#FFFFFF'
                                    }}>
                                    {[...Array(chunks)].map((_, rowIndex) => (
                                            <Row key={`${rowIndex}_row`} style={{width: internalChartLength}}>
                                                {[...Array(chunks)].map((_, columnIndex) => (
                                                    <ChartCol rowIndex={rowIndex} colIndex={columnIndex}
                                                              key={`${rowIndex}_${columnIndex}_cell`} span={2}/>))}
                                            </Row>
                                        )
                                    )}
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: 'column'
                                    }}>{[...Array(chunks)].map((_, columnIndex) => (
                                    <ColumnBoundaryCol key={`${columnIndex}_border`}></ColumnBoundaryCol>))}</div>
                            </div>
                            <Row style={{width: internalChartLength + elementSize * 2}}>
                                {[...Array(chunks + 2)].map((_, columnIndex) => (
                                    (columnIndex === 0) ?
                                        <CornerCell key={`${columnIndex}_border_h`}>
                                            <div style={{
                                                position: 'relative',
                                                top: "-50%",
                                                fontSize: "smaller"
                                            }}>{min}</div>
                                        </CornerCell>
                                        :
                                        <RowBoundaryCol key={`${columnIndex}_border`}>
                                            <div style={{
                                                position: 'relative',
                                                left: "-50%",
                                                fontSize: "smaller"
                                            }}>{min + stepSize * (columnIndex - 1)}</div>
                                        </RowBoundaryCol>))}
                            </Row>
                            <div style={{position: 'relative', top: -1 * elementSize / 2.5, fontSize: "small"}}>
                                {xAxis}
                            </div>
                        </div>
                    </div>
                    <Row><p style={{fontSize:"0.9em"}}><i>Generated from PhiSiCal-Checkup</i></p></Row>
                    </div>
                </TransformComponent>
            </TransformWrapper>
            <br/>
            <br/>
            <Row>
                {backgroundImageUrl ? <Button type="primary" icon={<DownloadOutlined />} size="large" onClick={()=>{
                    if (chartRef.current === null) {
                        Modal.error({
                            title: 'Oops !',
                            content: 'Something went wrong while downloading',
                        })
                    }

                    htmlToImage.toPng(chartRef.current, { backgroundColor: "white", quality:1})
                        .then((dataUrl) => {
                            const link = document.createElement('a')
                            link.download = `${fileName}.png`
                            link.href = dataUrl
                            link.click()
                        })
                        .catch((err) => {
                            Modal.error({
                                title: 'Oops !',
                                content: 'Something went wrong while downloading',
                            })
                        })

                }}>
                    Download Image
                </Button> : <></>}
            </Row>
        </div>


    )
}